export const GuideLevel = Object.freeze({
    BEGINNER: 0,
    INTERMEDIATE: 1,
    ADVANCED: 2
});
